import RegionalLayout from "./RegionalLayout";
import { FileCode2 } from "lucide-react";

const crd = {
  background: "var(--surface-card)",
  border: "var(--border-width, 1px) solid var(--border-default)",
  borderRadius: "1rem",
  boxShadow: "var(--shadow-card)",
};
const tp = { color: "var(--text-primary)" };
const ts = { color: "var(--text-secondary)" };

export default function AssessmentInsights() {
  return (
    <RegionalLayout>
      <div className="max-w-[1440px] mx-auto space-y-5">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight" style={tp}>Assessment Insights</h1>
          <p className="text-sm mt-0.5" style={ts}>Technical Assessment and Hands-On Simulation aggregate results</p>
        </div>
        <div className="p-12 flex flex-col items-center text-center" style={crd} data-testid="assessment-coming-soon">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "rgba(245,158,11,0.08)" }}>
            <FileCode2 className="w-8 h-8" style={{ color: "#f59e0b" }} />
          </div>
          <p className="text-lg font-semibold" style={tp}>Coming Soon</p>
          <p className="text-sm mt-2 max-w-md" style={ts}>
            TA and HOS performance by skill domain, score distribution across readiness tiers
            (Foundation, Proficient, Advanced, Expert). Data will populate as assessments are completed.
          </p>
          <div className="flex gap-2 mt-5">
            {["Foundation", "Proficient", "Advanced", "Expert"].map(d => (
              <span key={d} className="text-[10px] px-2.5 py-1 rounded-full font-medium"
                style={{ background: "var(--surface-inner)", color: "var(--text-secondary)" }}>{d}</span>
            ))}
          </div>
        </div>
      </div>
    </RegionalLayout>
  );
}
